// SPメニュー展開時、背景固定

const backgroundFix = (bool) => {
  if (!bool) {
    document.body.style.overflow = null;
  } else {
    document.body.style.overflow = 'hidden';
  }
};

// 変数定義

const CLASS = '-active';
let flg = false;
let oldLabel;
let newLabel;

let header = document.querySelector('.header');

let humberger = document.getElementById('js-navToggle');
let focusTrap = document.getElementById('js-focusTrap');

let screenSize = window.innerWidth;

// SPメニュー開閉制御

humberger.addEventListener('click', (e) => {
  e.currentTarget.classList.toggle(CLASS);
  header.classList.toggle(CLASS);
  if (flg) {// flgの状態で制御内容を切り替え
    backgroundFix(false);
    humberger.setAttribute('aria-expanded', 'false');
    humberger.setAttribute('aria-label', '総合メニューを開きます');
    humberger.focus();
    flg = false;
  } else {
    backgroundFix(true);
    humberger.setAttribute('aria-expanded', 'true');
    humberger.setAttribute('aria-label', '総合メニューを閉じます');
    flg = true;
  }
});

//メニュー escキー対応

window.addEventListener('keydown', () => {
  if (event.key === 'Escape') {
    humberger.classList.remove(CLASS);
    header.classList.remove(CLASS);

    backgroundFix(false);
    humberger.focus();
    humberger.setAttribute('aria-expanded', 'false');
    humberger.setAttribute('aria-label', '総合メニューを開きます');
    flg = false;
  }
});

// フォーカストラップ制御

focusTrap.addEventListener('focus', (e) => {
  humberger.focus();
});

// メニューリサイズ対応

const resize = ()=>{

  let timeoutID = 0;
  let delay = 500;
  let changeSize;

  window.addEventListener('resize', () => {
    clearTimeout(timeoutID);
    timeoutID = setTimeout(() => {
      changeSize = window.innerWidth;
      if(changeSize > 960) {
        if (flg) {
          // SPメニュー
          humberger.classList.remove(CLASS);
          header.classList.remove(CLASS);

          backgroundFix(false);
          humberger.setAttribute('aria-expanded', 'false');
          humberger.setAttribute('aria-label', '総合メニューを開きます');
          flg = false;
        }
      }
    }, delay);
  }, false);
};

resize();

//その他 アコーディオン制御

let accordiontrigger = document.querySelectorAll('.js-accordionTrigger');
let accordion = document.querySelectorAll('.js-accordion');

accordiontrigger.forEach((item) => {
  item.addEventListener('click', (e) => {
    if(e.currentTarget.getAttribute('aria-expanded') === 'true') {
      oldLabel = e.currentTarget.getAttribute('aria-label');
      if (oldLabel.indexOf('を閉じます')) {
        newLabel = oldLabel.replace('を閉じます', 'を開きます');
        e.currentTarget.setAttribute('aria-label', newLabel);
        e.currentTarget.setAttribute('aria-expanded', 'false');
        e.currentTarget.nextElementSibling.setAttribute('aria-hidden', 'true');
      }
    } else {
      // let count = 1;
      // for (let numClass of accordiontrigger) {
      //   if(numClass.getAttribute('aria-expanded') === 'true') {
      //     oldLabel = numClass.getAttribute('aria-label');
      //     if (oldLabel.indexOf('を閉じます')) {
      //       newLabel = oldLabel.replace('を閉じます', 'を開きます');
      //       numClass.setAttribute('aria-label', newLabel);
      //       numClass.setAttribute('aria-expanded', 'false');
      //       numClass.nextElementSibling.setAttribute('aria-hidden', 'true');
      //     }
      //   }
      //   count++;
      // }
      oldLabel = e.currentTarget.getAttribute('aria-label');
      if (oldLabel.indexOf('を開きます')) {
        newLabel = oldLabel.replace('を開きます', 'を閉じます');
      } else {
        newLabel = oldLabel.replace('を閉じます', 'を開きます');
      }
      e.currentTarget.setAttribute('aria-label', newLabel);
      e.currentTarget.setAttribute('aria-expanded', 'true');
      e.currentTarget.nextElementSibling.setAttribute('aria-hidden', 'false');
    }
  });
});

// スムーススクロール リンク

const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');

for (let i = 0; i < smoothScrollTrigger.length; i++){
  smoothScrollTrigger[i].addEventListener('click', (e) => {
    if (flg) {
      humberger.classList.remove(CLASS);
      header.classList.remove(CLASS);
      backgroundFix(false);
      humberger.setAttribute('aria-expanded', 'false');
      humberger.setAttribute('aria-label', '総合メニューを開きます');
      flg = false;
    }

    e.preventDefault();
    let href = smoothScrollTrigger[i].getAttribute('href');
    let targetElement = document.getElementById(href.replace('#', ''));
    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.scrollY;
    let gap;
    if( screenSize > 960) {
      gap = 0;
    } else {
      gap = 0;
    }
    const target = rect + offset - gap;
    window.scrollTo({
      top: target,
      behavior: 'smooth',
    });
  });
}

//pageTop

const pagetop = () => {
  const pagetopButton = document.querySelector('.pagetop');

  pagetopButton.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
};

pagetop();

// SP時ヘッダーの挙動

let lastScrollTop = 0;
const pagetopItem = document.querySelector('.pagetopWrap');

window.addEventListener('load', function(){
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    const body = document.body;
    body.dataset.scroll = y > 300 ? 'true' : 'false';

    const scrollCount = document.documentElement.scrollTop || document.body.scrollTop;

    const docHeight = document.body.clientHeight;
    const scrollPos = document.documentElement.clientHeight + scrollCount;
    const footerHeight = document.querySelector('.footer').clientHeight;
    if (docHeight - scrollPos <= footerHeight - 30) {
      pagetopItem.classList.add('scrolled');
    } else {
      pagetopItem.classList.remove('scrolled');
    }
  });
});

// タブ切り替え

const filterButtons = document.querySelectorAll('[data-filter]');
const categoryContents = document.querySelectorAll('[data-category]');

filterButtons.forEach((filterButton) => {
  filterButton.addEventListener('click', buttonSwitch);
  filterButton.addEventListener('click', categoryFilter);
});

function buttonSwitch() {
  filterButtons.forEach((filterButton) => {
    filterButton.classList.remove("-active");
    this.classList.add('-active');
  });
}

function categoryFilter() {
  const buttonCategory = this.dataset.filter;
  const targetContents = document.querySelectorAll('[data-category="' + buttonCategory + '"]');

  categoryContents.forEach((categoryContent) => {
    if (buttonCategory == 'all') {
      categoryContent.classList.add('-active');
    } else {
      categoryContent.classList.remove("-active");
      targetContents.forEach((targetContent) => {
        targetContent.classList.add('-active');
      });
    }
  });
}